import PropTypes from 'prop-types';
import { ActionRow, Button, ModalDialog } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../messages';

const DeleteTicketModal = ({
  isOpen, onClose, onConfirm, loading,
}) => {
  const intl = useIntl();
  const dialogTitle = intl.formatMessage(messages.deleteConfirmTitle);

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      hasCloseButton
      title={dialogTitle}
    >
      <ModalDialog.Header>
        <ModalDialog.Title>{dialogTitle}</ModalDialog.Title>
      </ModalDialog.Header>
      <ModalDialog.Body>
        <p className="mb-0">
          {intl.formatMessage(messages.deleteConfirmDescription)}
        </p>
      </ModalDialog.Body>
      <ModalDialog.Footer>
        <ActionRow>
          <Button variant="tertiary" onClick={onClose} disabled={loading}>
            {intl.formatMessage(messages.cancel)}
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={loading}>
            {intl.formatMessage(messages.delete)}
          </Button>
        </ActionRow>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};

DeleteTicketModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DeleteTicketModal.defaultProps = {
  loading: false,
};

export default DeleteTicketModal;
